import React from 'react';
import Modal from 'react-modal';
import Row from '../tag/Row';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import modal from '../../definitions/Modal';
import { FormattedMessage } from 'react-intl';
import Span from '../tag/Span';

const notificationModal = modal({ content: { width: '500px' } });

const HpaChangeModal = (props) => {
  let { hideModal, exitHpa, goToHpa, name, ...rest } = props;
  return (
    <Modal {...rest} ariaHideApp={false} style={notificationModal}>
      <Row>
        <p>
          <FormattedMessage id="hpa.confirm.change" values={{ name }} />
        </p>
      </Row>
      <Row>
        <OTButtonGroup fullWidth oneButtonPerRow type="big">
          <OTButton key="cancel" onClick={goToHpa}>
            <FormattedMessage id="hpa.change.continue" />
          </OTButton>

          <OTButton key="submit" onClick={exitHpa}>
            <FormattedMessage id="hpa.return" />
          </OTButton>

          <OTButton key="submit" onClick={hideModal}>
            <FormattedMessage id="cancel" />
          </OTButton>
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default HpaChangeModal;
